// Публичные маршруты — доступны без сессии; единый список для client.ts (не редиректить
// на /login при 401) и useAppRouting.ts (какой экран показывать), чтобы не разъезжались.
export const PUBLIC_PATHS = ["/login", "/activate"];
export function isPublicPath(pathname) {
    return PUBLIC_PATHS.includes(pathname);
}
